
(function() {
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      const format = window.themeMoneyFormat || window.Shopify.money_format || '${{amount}}';
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function(m) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'})[m];
    });
  }

  function openDrawer() {
    document.body.classList.add('av-drawer-open');
    const drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    document.body.classList.remove('av-drawer-open');
    const drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  function openMenu() {
    document.body.classList.add('av-menu-open');
    const drawer = document.querySelector('[data-menu-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }

  function closeMenu() {
    document.body.classList.remove('av-menu-open');
    const drawer = document.querySelector('[data-menu-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  function drawerItemHtml(item, index) {
    const img = item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}">` : '';
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : '';
    return `
      <div class="av-drawer-item" data-cart-line="${index}">
        <div class="av-drawer-item__image">${img}</div>
        <div class="av-drawer-item__info">
          <div class="av-drawer-item__top">
            <h3>${escapeHtml(item.product_title)}</h3>
            <button type="button" data-cart-remove aria-label="Remove item">×</button>
          </div>
          ${variantTitle}
          <div class="av-drawer-item__bottom">
            <div class="av-drawer-qty">
              <button type="button" data-cart-minus>−</button>
              <input type="number" min="0" value="${item.quantity}" data-cart-qty aria-label="Quantity">
              <button type="button" data-cart-plus>+</button>
            </div>
            <strong>${formatMoney(item.final_line_price)}</strong>
          </div>
        </div>
      </div>`;
  }

  async function refreshCartDrawer(shouldOpen) {
    try {
      const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }}).then(r => r.json());
      document.querySelectorAll('[data-cart-count], .cart-count').forEach(el => el.textContent = cart.item_count);

      const body = document.querySelector('[data-cart-drawer-body]');
      const footer = document.querySelector('[data-cart-drawer-footer]');
      const subtotal = document.querySelector('[data-cart-subtotal]');

      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      if (body) {
        if (cart.item_count === 0) {
          body.innerHTML = `
            <div class="av-cart-drawer__empty">
              <h3>Your cart is empty</h3>
              <p>Discover soft, comfortable everyday styles made to move with you.</p>
              <a href="/collections/all">Continue Shopping</a>
            </div>`;
          if (footer) footer.hidden = true;
        } else {
          body.innerHTML = `<div class="av-cart-drawer__items">${cart.items.map((item, i) => drawerItemHtml(item, i + 1)).join('')}</div>`;
          if (footer) footer.hidden = false;
        }
      }
      if (shouldOpen) openDrawer();
    } catch(e) {
      if (shouldOpen) window.location.href = '/cart';
    }
  }

  async function changeLine(line, quantity) {
    try {
      await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({ line: line, quantity: quantity })
      });
      await refreshCartDrawer(false);
    } catch(e) {
      window.location.href = '/cart';
    }
  }

  function getProductVariants(page) {
    const script = page.querySelector('[data-cj-variants-json]');
    if (!script) return [];
    try { return JSON.parse(script.textContent || '[]'); } catch(e) { return []; }
  }

  function getOptionGroups(page) {
    return Array.from(page.querySelectorAll('[data-cj-option-group]'))
      .sort((a, b) => Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index')));
  }

  function getGroupValue(group) {
    const select = group.querySelector('[data-cj-option-select]');
    if (select) return select.value;

    const checked = group.querySelector('[data-cj-option-input]:checked');
    return checked ? checked.value : '';
  }

  function setGroupValue(group, value) {
    const select = group.querySelector('[data-cj-option-select]');
    if (select) {
      select.value = value;
      return;
    }

    const radio = Array.from(group.querySelectorAll('[data-cj-option-input]')).find(input => input.value === value);
    if (radio) radio.checked = true;
  }

  function getSelectedOptions(page) {
    return getOptionGroups(page).map(group => getGroupValue(group));
  }

  function setMessage(page, text, type) {
    const msg = page.querySelector('[data-cj-form-message]');
    if (!msg) return;
    if (!text) {
      msg.hidden = true;
      msg.textContent = '';
      msg.classList.remove('is-success');
      return;
    }
    msg.hidden = false;
    msg.textContent = text;
    msg.classList.toggle('is-success', type === 'success');
  }

  function findExactVariant(variants, selected) {
    return variants.find(v => v.options.every((opt, idx) => opt === selected[idx]));
  }

  function findFirstAvailableVariant(variants) {
    return variants.find(v => v.available) || variants[0];
  }

  function syncControlsToVariant(page, variant) {
    if (!variant) return;
    getOptionGroups(page).forEach((group, idx) => {
      if (variant.options[idx] !== undefined) setGroupValue(group, variant.options[idx]);
    });
  }

  function markUnavailableOptions(page, variants) {
    const groups = getOptionGroups(page);
    const selected = getSelectedOptions(page);

    groups.forEach((group, index) => {
      const select = group.querySelector('[data-cj-option-select]');
      if (select) {
        Array.from(select.options).forEach(option => {
          const original = option.getAttribute('data-original-label') || option.value;
          option.setAttribute('data-original-label', original);

          const test = selected.slice();
          test[index] = option.value;

          const possible = variants.some(v => v.available && v.options.every((opt, idx) => opt === test[idx]));
          option.disabled = !possible && option.value !== select.value;
          option.textContent = original + (!possible && option.value !== select.value ? ' - Sold out' : '');
        });
      } else {
        Array.from(group.querySelectorAll('[data-cj-option-input]')).forEach(input => {
          const test = selected.slice();
          test[index] = input.value;
          const possible = variants.some(v => v.available && v.options.every((opt, idx) => opt === test[idx]));
          input.disabled = !possible && !input.checked;
        });
      }
    });
  }

  function updateProductVariant(page, forceFirstAvailable) {
    const variants = getProductVariants(page);
    if (!variants.length) return null;

    let selected = getSelectedOptions(page);
    let variant = findExactVariant(variants, selected);

    if (forceFirstAvailable || !variant || !variant.available) {
      const firstAvailable = findFirstAvailableVariant(variants);
      if (firstAvailable && firstAvailable.available) {
        variant = firstAvailable;
        syncControlsToVariant(page, variant);
        selected = getSelectedOptions(page);
      }
    }

    markUnavailableOptions(page, variants);

    const hiddenInput = page.querySelector('[data-cj-variant-id]');
    const atc = page.querySelector('[data-cj-atc]');
    const mainImage = page.querySelector('[data-cj-main-image]');
    const compare = page.querySelector('[data-cj-compare]');

    if (!variant) {
      if (hiddenInput) hiddenInput.value = '';
      if (atc) {
        atc.disabled = true;
        atc.innerHTML = 'Unavailable';
      }
      return null;
    }

    if (hiddenInput) hiddenInput.value = variant.id;
    page.querySelectorAll('[data-cj-price]').forEach(el => el.textContent = formatMoney(variant.price));

    if (compare && variant.compare_at_price && variant.compare_at_price > variant.price) {
      compare.textContent = formatMoney(variant.compare_at_price);
    }

    if (atc) {
      atc.disabled = !variant.available;
      atc.innerHTML = variant.available
        ? atc.getAttribute('data-label') + ' — ' + formatMoney(variant.price)
        : 'Sold out';
    }

    if (variant.featured_image && variant.featured_image.src && mainImage) {
      mainImage.src = variant.featured_image.src;
    }

    if (variant.available) setMessage(page, '', '');
    return variant;
  }

  

  async function refreshNativeThemeCartSections() {
    try {
      const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
      const url = (window.location.pathname || '/') + '?sections=' + sectionIds.join(',');
      const sections = await fetch(url, { headers: { 'Accept': 'application/json' }}).then(r => r.json());

      if (sections['cart-drawer']) {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        const currentDrawer = document.querySelector('cart-drawer');

        if (currentDrawer && newDrawer) {
          currentDrawer.outerHTML = newDrawer.outerHTML;
        } else if (!currentDrawer && newDrawer) {
          document.body.insertAdjacentHTML('beforeend', newDrawer.outerHTML);
        }
      }

      if (sections['cart-icon-bubble']) {
        const iconDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const iconHtml = iconDoc.body ? iconDoc.body.innerHTML : sections['cart-icon-bubble'];

        const currentSection = document.querySelector('#shopify-section-cart-icon-bubble');
        if (currentSection) {
          currentSection.innerHTML = iconHtml;
        } else {
          const headerCartIcon = document.querySelector('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"]');
          if (headerCartIcon) {
            const existingBubble = headerCartIcon.querySelector('.cart-count-bubble');
            if (existingBubble) existingBubble.remove();
            headerCartIcon.insertAdjacentHTML('beforeend', iconHtml);
          }
        }
      }

      await new Promise(resolve => setTimeout(resolve, 100));
      return true;
    } catch(e) {
      return false;
    }
  }

  async function openExistingThemeCart() {
    // Refresh the native Shrine cart drawer first, otherwise it can open stale/empty.
    await refreshNativeThemeCartSections();

    try {
      if (window.PUB_SUB_EVENTS && window.publish && window.PUB_SUB_EVENTS.cartUpdate) {
        const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }}).then(function(r){ return r.json(); });
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'comfijeans-product', cartData: cart });
      }
    } catch(e) {}

    const nativeDrawer = document.querySelector('cart-drawer');
    if (nativeDrawer && typeof nativeDrawer.open === 'function') {
      try {
        nativeDrawer.open();
        return;
      } catch(e) {}
    }

    const cartLink = document.querySelector('a[href="/cart"], a[href$="/cart"], .site-header__icon-btn[aria-label="Cart"]');
    if (cartLink) {
      setTimeout(function() { cartLink.click(); }, 150);
      return;
    }

    setTimeout(function() { window.location.href = '/cart'; }, 150);
  }


  function switchComfiJeansGalleryImage(thumb) {
    if (!thumb) return;
    var page = thumb.closest('.cj-page');
    if (!page) return;

    var main = page.querySelector('[data-cj-main-image]');
    var url = thumb.getAttribute('data-cj-image');
    if (!main || !url) return;

    // Shopify image_tag outputs srcset/sizes. If only src changes, the browser can keep using the old srcset.
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.removeAttribute('data-srcset');
    main.removeAttribute('data-src');
    main.srcset = '';
    main.sizes = '';
    main.src = url;

    var altImg = thumb.querySelector('img');
    if (altImg && altImg.alt) main.alt = altImg.alt;

    page.querySelectorAll('[data-cj-image]').forEach(function(btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-selected', 'false');
    });

    thumb.classList.add('is-active');
    thumb.setAttribute('aria-selected', 'true');
  }



  function switchComfiJeansGalleryImage(thumb, event) {
    if (!thumb) return;
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    var page = thumb.closest('.cj-page');
    if (!page) return;

    var main = page.querySelector('[data-cj-main-image]');
    if (!main) return;

    var fullUrl = thumb.getAttribute('data-cj-image');
    var thumbImg = thumb.querySelector('img');
    var instantUrl = thumbImg ? (thumbImg.currentSrc || thumbImg.src) : fullUrl;

    if (!fullUrl && !instantUrl) return;

    // Instantly switch to the already-loaded thumbnail first so the user sees feedback immediately.
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.removeAttribute('data-srcset');
    main.removeAttribute('data-src');
    main.srcset = '';
    main.sizes = '';
    main.style.opacity = '0.92';
    main.src = instantUrl || fullUrl;

    if (thumbImg && thumbImg.alt) main.alt = thumbImg.alt;

    page.querySelectorAll('[data-cj-image]').forEach(function(btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-selected', 'false');
    });
    thumb.classList.add('is-active');
    thumb.setAttribute('aria-selected', 'true');

    // Then load the full-size image and replace it once ready.
    if (fullUrl && fullUrl !== instantUrl) {
      var preloader = new Image();
      preloader.onload = function() {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = fullUrl;
        main.style.opacity = '1';
      };
      preloader.onerror = function() {
        main.style.opacity = '1';
      };
      preloader.src = fullUrl;
    } else {
      main.style.opacity = '1';
    }
  }

  function bindComfiJeansGallery(scope) {
    (scope || document).querySelectorAll('[data-cj-image]').forEach(function(thumb) {
      if (thumb.dataset.cjGalleryBound === 'true') return;
      thumb.dataset.cjGalleryBound = 'true';
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');

      ['pointerdown', 'mousedown', 'touchend', 'click'].forEach(function(evtName) {
        thumb.addEventListener(evtName, function(e) {
          switchComfiJeansGalleryImage(thumb, e);
        }, { capture: true });
      });

      thumb.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          switchComfiJeansGalleryImage(thumb, e);
        }
      }, { capture: true });
    });
  }


function initProducts(scope) {
    bindComfiJeansGallery(scope || document);
    (scope || document).querySelectorAll('[data-cj-product]').forEach(page => {
      const variants = getProductVariants(page);
      const selectedVariant = findExactVariant(variants, getSelectedOptions(page));

      if (!selectedVariant || !selectedVariant.available) {
        updateProductVariant(page, true);
      } else {
        updateProductVariant(page, false);
      }

      page.querySelectorAll('[data-cj-option-select], [data-cj-option-input]').forEach(control => {
        control.addEventListener('change', () => updateProductVariant(page, false));
      });

      const form = page.querySelector('form[action*="/cart/add"]');
      if (form && !form.closest('product-form') && !form.dataset.cjBound) {
        form.dataset.cjBound = 'true';
        form.addEventListener('submit', async function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();

          let variant = updateProductVariant(page, false);
          if (!variant || !variant.available) {
            variant = updateProductVariant(page, true);
          }

          if (!variant || !variant.available) {
            setMessage(page, 'This selected option is sold out. Please choose another available color, size or inseam.', 'error');
            return;
          }

          const atc = form.querySelector('[data-cj-atc]');
          const original = atc ? atc.innerHTML : '';

          if (atc) {
            atc.disabled = true;
            atc.innerHTML = 'Adding...';
          }

          try {
            const fd = new FormData(form);
            fd.set('id', String(variant.id));

            const res = await fetch('/cart/add.js', {
              method:'POST',
              body: fd,
              headers: { 'Accept':'application/json' }
            });

            if (!res.ok) {
              let errorMessage = 'This option is currently sold out. Please choose another size, color or inseam.';
              try {
                const errorJson = await res.json();
                if (errorJson && errorJson.description) errorMessage = errorJson.description;
                if (errorJson && errorJson.message) errorMessage = errorJson.message;
              } catch(err) {}
              setMessage(page, errorMessage, 'error');
              return;
            }

            await res.json().catch(function(){ return {}; });
            setMessage(page, 'Added to cart.', 'success');
            await refreshCartDrawer(false);
            await refreshNativeThemeCartSections();
            await openExistingThemeCart();
          } catch(err) {
            setMessage(page, 'Could not add this item to cart. Please refresh and try again.', 'error');
          } finally {
            if (atc) {
              atc.disabled = false;
              updateProductVariant(page, false);
            }
          }
        }, true);
      }
    });
  }

  document.addEventListener('click', function(e) {
    const menuToggle = e.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      e.preventDefault();
      openMenu();
      return;
    }

    if (e.target.closest('[data-menu-close]')) {
      e.preventDefault();
      closeMenu();
      return;
    }

    const minus = e.target.closest('[data-cart-minus], [data-ac-minus]');
    const plus = e.target.closest('[data-cart-plus], [data-ac-plus]');
    const remove = e.target.closest('[data-cart-remove], [data-ac-remove]');
    if (minus || plus || remove) {
      const item = e.target.closest('[data-cart-line], [data-line]');
      if (!item) return;
      e.preventDefault();
      const line = Number(item.getAttribute('data-cart-line') || item.getAttribute('data-line'));
      const qty = item.querySelector('[data-cart-qty], [data-ac-qty]');
      const currentQty = qty ? Number(qty.value || 0) : 0;
      const nextQty = remove ? 0 : Math.max(0, currentQty + (plus ? 1 : -1));
      changeLine(line, nextQty);
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-cart-qty], [data-ac-qty]')) {
      const item = e.target.closest('[data-cart-line], [data-line]');
      if (!item) return;
      const line = Number(item.getAttribute('data-cart-line') || item.getAttribute('data-line'));
      const nextQty = Math.max(0, Number(e.target.value || 0));
      changeLine(line, nextQty);
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeMenu();
    }
  });


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { bindComfiJeansGallery(document); bindComfiJeansGallery(document); initProducts(document); });
  } else {
    bindComfiJeansGallery(document); initProducts(document);
  }
})();


/* V3 Phoenix checkout safety: keep current theme Phoenix script in control. */
document.addEventListener('click', function(e) {
  var btn = e.target.closest && e.target.closest('[data-phx-cart-checkout]');
  if (!btn) return;
  // Phoenix script normally intercepts this via CART_CHECKOUT_SELECTORS.
  // This is only a last fallback when the selector hook has not bound yet.
  if (!btn._phxBound && !btn.dataset.phxFallbackBusy) {
    e.preventDefault();
    btn.dataset.phxFallbackBusy = '1';
    window.location.href = '/checkout';
  }
}, false);
